import api, { formDataInstance } from "./baseRequest";

export const homepageImagesService = {
  getAllHomepageImages: (pageOptions = {}) => {
    const params = new URLSearchParams();
    if (pageOptions.page) params.append("page", pageOptions.page);
    if (pageOptions.limit) params.append("limit", pageOptions.limit);
    if (pageOptions.sortBy) params.append("sortBy", pageOptions.sortBy);
    if (pageOptions.sortOrder)
      params.append("sortOrder", pageOptions.sortOrder);

    return api.get(`/homepage-images?${params.toString()}`);
  },

  getAllHomepageImagesWithoutPagination: () => {
    return api.get("/homepage-images/all");
  },

  getHomepageImageById: (id) => {
    return api.get(`/homepage-images/${id}`);
  },

  createHomepageImage: (imageData) => {
    const formData = new FormData();
    if (imageData.image) {
      formData.append("image", imageData.image);
    }

    return formDataInstance.post("/admin/homepage-images", formData);
  },

  updateHomepageImage: (id, imageData) => {
    const formData = new FormData();
    if (imageData.image) {
      formData.append("image", imageData.image);
    }

    return formDataInstance.put(`/admin/homepage-images/${id}`, formData);
  },

  deleteHomepageImage: (id) => {
    return api.delete(`/admin/homepage-images/${id}`);
  },

  reorderHomepageImages: (homepageImageIds) => {
    return api.patch("/admin/homepage-images/reorder", { homepageImageIds });
  },
};
